import { Link } from "react-router-dom"

const NotFound = () => {
  return (
    <div className="not-found">
      <p>Die Seite existiert nicht. <Link to="/">Zurück zum Dashboard.</Link></p>
    </div>
  )
}
 
export default NotFound